import { Component } from '@angular/core';

@Component({
    selector: 'fullscreen-page',
    templateUrl: './fullscreen-page.component.html',
    styleUrls: ["./fullscreen-page.component.css"],
    standalone: false
})
export class FullscreenPageComponent {

}